module.exports = __webpack_public_path__ + "static/media/alagoz-holding.aa098b20.png";